import { API } from "@/lib/api";

/**
 * Builds a questionnaire presign URL with token authentication.
 * Used for presigning URLs for questionnaire attachments.
 */
export const buildQuestionnairePresignUrl = (
  agreementId: string | undefined,
  token: string,
): string => {
  if (!agreementId) {
    return "";
  }
  return `${API.Agreements}/${agreementId}/questionnaire/attachments/presign?token=${encodeURIComponent(token)}`;
};
